import AnalyticsVideoPlayer from "@/ui/composed/media/videoPlayer/layers/AnalyticsVideoPlayer";

// expose this video player as the default option, to hide from any other layers of the video player
export default AnalyticsVideoPlayer;
